import { Link } from "react-router-dom";

export default function TFDSelectInternationalTours() {
	return (
		<div className="tfd-select-international-tours">
			{/* Hero */}
			<section className="tf-hero-international-tours">
				<div className="hero-image-wrap">
					<img
						src="/images/select/international-hero.jpg"
						alt="International Tours Hero"
						className="hero-bg-image"
					/>
					<div className="overlay-dark" />
					<div className="hero-content themeflat-container">
						<h1 className="hero-title wow fadeInUp animated">
							International Tours
						</h1>
						<p className="hero-subtitle wow fadeInUp animated">
							Discover football beyond borders
						</p>
						<Link to="/contact" className="flat-button wow fadeInUp animated">
							Coming Soon
						</Link>
					</div>
				</div>
			</section>

			{/* Info */}
			<section className="tf-international-info main-content">
				<div className="themeflat-container">
					<div className="row">
						<div className="col-12 wow fadeInUp animated">
							<div className="title-box center-title-box title-large">
								<h2 className="title-section">Play on the Global Stage</h2>
								<p className="sub-title">
									Experience new cultures, face international competition, and
									expand your horizons.
								</p>
							</div>
							<p style={{ maxWidth: "800px", margin: "0 auto" }}>
								Our International Tours are an unforgettable opportunity for
								young players to test their skills abroad, immerse in different
								footballing styles, and create lifelong memories. Official
								details (dates &amp; destinations) will be posted soon.
							</p>
							<div className="text-center mt-4">
								<Link to="/contact" className="flat-button">
									Express Interest
								</Link>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
